import angular from 'angular';
import mycrmGender from './mycrmGender';

export default angular
  .module('components.mycrmGender', [])
  .component('mycrmGender', mycrmGender).name;
